const DEFAULT = 'NOT_STARTED';
const LOADING = 'LOADING';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const ACCOUNT = {
    SETUP: "SETUP",
    NOT_SET: "NOT_SET",
}

export const STATUS = Object.freeze({ DEFAULT, LOADING, SUCCESS, ERROR, ACCOUNT });

export const TRANSACTION_STATUS = Object.freeze({
    PROCESSING: 1,
    SUCCESS: 2,
    INITIATED: 3,
    PENDING: 4,
    FAILED: 5,
    HOLDING: 6,
    ERROR: 7,
    COMMISSION_RECORDED_SUCCESSFUL: 100,
    COMMISSION_PROCESSING: 101,
    FAILED_RECORDING_COMMISSION: 102,
});

export const isSuccessStatus = (status: number): boolean => {
    return [2, 100, 101, 102].includes(status);
};

export const getStatusColor = (status: number): 'success' | 'danger' | 'warning' | 'neutral' | 'primary' => {
    if (status === 2) return 'success';
    if ([100, 101, 102].includes(status)) return 'primary';
    if (status === 5 || status === 7) return 'danger';
    if (status === 1 || status === 4) return 'warning';
    if (status === 3) return 'primary';
    return 'neutral';
};

export const getStatusLabel = (status: number): string => {
    const labels: Record<number, string> = {
        1: 'Processing',
        2: 'Success',
        3: 'Initiated',
        4: 'Pending',
        5: 'Failed',
        6: 'Holding',
        7: 'Error',
        100: 'Commission Recorded',
        101: 'Commission Processing',
        102: 'Commission Failed',
    };
    return labels[status] ?? 'Unknown';
};

